import type { JSX } from 'react'
import type { INoContentBlockProps } from '../NoContentBlock'

import { DESCRIPTION_PADDINGS, NoContentIconSizes } from 'vars/index'
import {
  NoContentBlockAlignItems,
  NoContentBlockDirection,
  NoContentBlockJustifyContent,
} from '../NoContentBlock.h'
import { FluidHeightNoContentBlockSC } from './FluidHeightNoContentBlock.styled'

export interface IFluidHeightNoContentBlockProps extends INoContentBlockProps {}

export const FluidHeightNoContentBlock = ({
  children,
  width = '100%',
  direction = NoContentBlockDirection.Column,
  alignItems = NoContentBlockAlignItems.Center,
  justifyContent = NoContentBlockJustifyContent.Center,
  flexGrow = 1,
  paddings = DESCRIPTION_PADDINGS.SIZE_10,
  iconSize = NoContentIconSizes.DEFAULT,
  ...rest
}: IFluidHeightNoContentBlockProps): JSX.Element => (
  <FluidHeightNoContentBlockSC
    width={width}
    direction={direction}
    alignItems={alignItems}
    justifyContent={justifyContent}
    flexGrow={flexGrow}
    paddings={paddings}
    iconSize={iconSize}
    {...rest}
  >
    {children}
  </FluidHeightNoContentBlockSC>
)
